import './App.css';
import Header from './Header';
import Form from "./Form"
import Body from "./Body"

function App() {
  return (
    <div className="App">
      <Header />
      <Body />
      <Form />
     
    </div>
  );
}

export default App;
